export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/7012d7e4ba8166f605b642a8a46089ea.jpg"
          alt="台灣青年學習"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative h-full max-w-7xl mx-auto px-6 flex flex-col justify-between py-24">
        <div className="mt-20">
          <h1 className="text-7xl font-bold text-white leading-tight">
            讓潛力被看見<br />
            讓努力被肯定
          </h1>
        </div>

        <div className="flex items-end justify-between">
          <button
            onClick={() => scrollToSection('eligibility')}
            className="group flex items-center gap-3 bg-white rounded-full pl-6 pr-2 py-2 hover:shadow-lg transition-all cursor-pointer whitespace-nowrap"
          >
            <span className="text-sm font-medium text-gray-900">了解申請資格</span>
            <div className="w-10 h-10 bg-black rounded-full flex items-center justify-center">
              <i className="ri-arrow-right-line text-white text-lg"></i>
            </div>
          </button>

          <div className="text-right">
            <p className="text-xl text-white font-light leading-relaxed">
              少華獎｜Shao-Hua Award<br />
              支持台灣青年發展的長期培力計畫
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
